import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

export class Loading extends React.PureComponent {

    static defaultProps = {
        isLarge: false,
        isCentered: true
    }

    static propTypes = {
        isLarge: PropTypes.bool,
        isCentered: PropTypes.bool
    }

    constructor(props) {
        super(props);
    }

    render() {
        let className = this.props.className || 'margin-top-md margin-bottom-md';
        if (this.props.isLoading) {
            return (<div key="react-loading" className={cx(className,'circle', {
                'circle--lg': this.props.isLarge,
                'circle--centered': this.props.isCentered
            })}></div>)
        } else {
            return this.props.children;
        }
    }
}